import { render, staticRenderFns } from "./ListaDistribucion.vue?vue&type=template&id=67aa0bf6&"
import script from "./ListaDistribucion.vue?vue&type=script&lang=ts&"
export * from "./ListaDistribucion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('67aa0bf6', component.options)
    } else {
      api.reload('67aa0bf6', component.options)
    }
    module.hot.accept("./ListaDistribucion.vue?vue&type=template&id=67aa0bf6&", function () {
      api.rerender('67aa0bf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ListaDistribucion/ListaDistribucion.vue"
export default component.exports